import { all, select, takeEvery, fork, put, call } from 'redux-saga/effects'

// action
import { inquiryActions } from '@redux/store/index'

// lib
import { Logger } from '@utils'
import { Validator, ValidatorResultType } from '@validators'
import { InquiryType } from '@schemas'
import { produce } from 'immer'

// api
import { seasonProductApi, ResType, inquiryApi } from '@api'

// type
import type { InquiryStateType } from '@redux/types'

const apiAddInquriy = async (body: {
	name: string
	email: string
	categ: string
	message: string
}): Promise<ResType | undefined> => {
	const res: ResType | undefined = await inquiryApi.addInquiry({
		body: body,
	})
	return res
}

function* triggerInitInquiryPageSaga() {
	try {
		yield
	} catch (error) {
		Logger.warn(error)
	}
}

function* triggerSendInquirySaga() {
	try {
		const newInquiry: InquiryType = yield select(state => state.inquiry.insertInquiry)
		const errorMessages: InquiryStateType['inquiryErrorMessage'] = yield select(
			state => state.inquiry.inquiryErrorMessage,
		)

		const res: ValidatorResultType = Validator.inquiry({
			...newInquiry,
		})

		const filterInvalidRes = Object.keys(res).filter(aKey => !res[aKey].isValid)
		const isSuccess = filterInvalidRes.length === 0

		const newErrorMessage = produce(errorMessages, draft => {
			draft.name = res.name.message
			draft.email = res.email.message
			draft.categ = res.categ.message
			draft.message = res.message.message
		})

		yield put(inquiryActions.INQUIRY_ERROR_MESSAGE({ ...newErrorMessage }))

		if (isSuccess) {
			const apiRes: ResType = yield call(apiAddInquriy, newInquiry)

			if (apiRes.status === 201) {
				yield put(
					inquiryActions.MODAL_INFO({
						target: 'submitSuccess',
						title: 'Submit Success',
					}),
				)
				yield put(inquiryActions.SHOW_MODAL(true))
			} else {
				yield put(
					inquiryActions.MODAL_INFO({
						target: 'submitError',
						title: 'Submit Failed',
					}),
				)
				yield put(inquiryActions.SHOW_MODAL(true))
			}
		}
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(inquiryActions.TRIGGER_INIT_INQUIRY_PAGE, triggerInitInquiryPageSaga)
	yield takeEvery(inquiryActions.TRIGGER_SEND_INQUIRY, triggerSendInquirySaga)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
